import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  fetchWorkingDaysFailure,
  fetchWorkingDaysSuccess,
} from "../slices/features/workingDays";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* getWorkingDaysSaga(action: any) {
  const { payload } = action;
  const { id } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.getWorkingDays,
      baseUrl,
      id
    );

    yield put(fetchWorkingDaysSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess(response);
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchWorkingDaysFailure({ statusCode, statusText }));
  }
}

export function* watchGetWorkingDays() {
  yield takeLatest(RequestTypes.GET_WORKING_DAYS_REQUEST, getWorkingDaysSaga);
}
